import {
  FinnairApis,
  FinnairCheckInTravelerEligibility,
  FinnairPassengerItem,
  FinnairServiceItem,
} from '@fcom/dapi/api/models';
import { FrequentFlyerCardItemWithTranslations } from '@fcom/common-booking/interfaces/passenger.interface';

export type PassengerWithCheckInInfo = FinnairPassengerItem & {
  isCheckedIn: boolean;
  isStandby: boolean;
  isAllowedToUseCheckIn: boolean;
  isAllowedToUseBoardingPass: boolean;
  withInfant: string | null;
  hasUnrecoverableReason: boolean;
};

export interface FinnairCheckInPassengerEligibilityForFlight extends FinnairCheckInTravelerEligibility {
  flightId: string;
}

export interface FinnairPassengerItemWithApis extends FinnairPassengerItem {
  apisCpr?: FinnairApis;
  dcsTravelerId?: string;
  isInAgentReval?: boolean;
  eligibilities?: FinnairCheckInPassengerEligibilityForFlight[];
  verifierDetails?: VerifierDetails;
}

export interface VerifierDetails {
  passportSwiped: boolean;
  entryDocumentSwiped?: boolean;
  completedEntryDocumentType?: EntryDocumentType;
  started: boolean;
  completed: boolean;
}

export interface BoardingPassIncludedServicesRequest {
  loading: boolean;
  error?: unknown;
  data?: FinnairServiceItem[];
}

export type ExtendedFinnairPassengerItem = PassengerWithCheckInInfo & {
  paxTypeKey: string;
  cards: FrequentFlyerCardItemWithTranslations[];
};

export enum EntryDocumentType {
  VISA = 'visa',
  RESIDENT = 'permanentResidentCard',
}

export type CheckInRedirectionType = 'check-in' | 'modify' | 'boarding-pass';
